import { render } from "./SolutionInfo.vue?vue&type=template&id=ae5ff4c0&scoped=true&ts=true"
import script from "./SolutionInfo.vue?vue&type=script&lang=ts"
export * from "./SolutionInfo.vue?vue&type=script&lang=ts"

import "./SolutionInfo.vue?vue&type=style&index=0&id=ae5ff4c0&lang=scss&scoped=true"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae5ff4c0"]])

export default __exports__